import moment from 'moment';

import { GetLiveFnsku } from '../../../../../../../slices/post-shipment';
import productLabel from '../../../../../../../utils/print-labels/productLabel';
import { isValidFnsku, notifyMissingFnsku, isFnskuLabelSuppressed, notifyFnskuLabelSuppressed } from './packNowLabelHelpers';

/**
 * Standalone FNSKU sticker print — independent of the plan/packing flow.
 *
 * Fetches the live, authoritative FNSKU from Amazon (read-only; does not touch
 * work_order_items_v2 / seller_skus) and prints the product label. Strict: if the
 * SKU is missing or Amazon returns no FNSKU, it toasts and prints nothing.
 *
 * @param {function} dispatch  redux dispatch
 * @param {object}   args
 * @param {string|number} args.workOrderId
 * @param {object}   args.item          the product/packing item (needs msku/sku, item_name, etc.)
 * @param {number}   args.numberOfLabels
 * @returns {Promise<boolean>} true if a label was generated, false if aborted
 */
export const printFnskuLabelLive = async (dispatch, { workOrderId, item, numberOfLabels }) => {
  const {
    item_name,
    prep_instructions,
    expiration,
    min_bundle_quantity: bundleQty,
    label_owner,
  } = item || {};
  const sku = item?.msku || item?.sku;

  // Amazon label owner NONE -> the item ships on its manufacturer barcode; no FNSKU label
  // (checked before the live-FNSKU fetch so we don't call Amazon for nothing).
  if (isFnskuLabelSuppressed(label_owner)) {
    notifyFnskuLabelSuppressed(item_name || sku);
    return false;
  }

  if (!sku) {
    notifyMissingFnsku(item_name);
    return false;
  }

  const { payload } = await dispatch(GetLiveFnsku({ workOrderId, sku }));
  const liveFnsku = payload?.fnsku;

  if (!isValidFnsku(liveFnsku)) {
    notifyMissingFnsku(item_name || sku);
    return false;
  }

  productLabel({
    fnsku: liveFnsku,
    title: item_name || '',
    expiryDate: expiration ? moment(expiration).format('MM-DD-YYYY') : 'N/A',
    bundleQty,
    numberOfLabels: Number(numberOfLabels),
    username: 'Opulent',
    prepInstruction: prep_instructions,
    labelOwner: label_owner,
  });

  return true;
};
